import styled from "styled-components";

export default styled('div')`
/**
  Class for centered Text based pages
  i.e. Warranty and Shipping Acceptance
**/
.contentPage {
  isolation: isolate; // Isolate all child z-indices.
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .h1 {
    text-align: center;
    margin-top: 2rem;
  }

  .subTitle {
    margin-left: auto;
    margin-right: auto;
    max-width: 800px;
  }

  > .content {
    display: flex;
    flex-direction: column;
    align-self: center;
    width: 100%;

    > * {
      width: 100%;
      margin-bottom: 4rem;
      align-self: center;
      padding: 0 0.5rem;

      @media (min-width: 770px) {
        padding: 0;
      }
    }

    > *:not(.fullWidth) {
      max-width: 800px;
    }

    // Handle use case where Hero Banner doesn't want any top margin
    // TODO: STORE-2827 Background Styles in widget sections from contentful break styles for hero banner.
    > *:first-child:not(.HeroBanner) {
      margin-top: 2rem;
    }

    .h2 {
      text-align: center;
      margin-bottom: 1rem;
    }

    /** Contentful driven Classes **/
    > .fullWidth {

      // Provide blue full-width with large padding because not same color as normal bg
      &.blueFullWidth {
        background-color: #f6fbfd;
        padding: 4rem 0;
      }

      &.darkBlueFullWidth {
        padding: 4rem 0;
        background-color: #009fb0;
        color: #fbfbfb;
      }

      &.greyFullWidth {
        display: flex;
        justify-content: center;
        background-color: #f6fbfd;

        > * {
          width: 800px;
          margin: 4rem 0 3rem 0;

          &.fullWidth {
            width: 100%;
            margin: 0;

            @media (min-width: 770px) {
              margin: 1rem;
            }
          }

          // font-color-lighter isn't very visible on grey background.
          .markdown {
            h3 {
              color: #334b4f;
            }
          }
        }
      }

      &.contentWide {
        display: flex;
        flex-direction: column;
        align-items: center;

        > * {
          width: auto;
          max-width: 100%;
          padding-left: 2rem;
          padding-right: 2rem;

          @media (min-width: 960px) {
            width: auto;
            max-width: 1440px;
            padding-left: 4rem;
            padding-right: 4rem;
          }
        }
      }

      &.contentFull {
        > * {
          width: auto;
          max-width: 100%;
          padding-left: 2rem;
          padding-right: 2rem;

          @media (min-width: 770px) {
            width: auto;
            max-width: 100%;
            padding-left: 4rem;
            padding-right: 4rem;
          }
        }
      }

      &.noMarginTop {
        margin-top: 0;
      }

      &.noMarginBottom {
        margin-bottom: 0;
      }

      &.blackBackground {
        background-color: black;
        color: #fbfbfb;

        .h2 {
          color: #fbfbfb;
        }
      }

      /* hiddenSection defined in sections.less so that both clients can use */

      &.hiddenSection {
        display: none;
      }

      &.hiddenDesktop {
        @media (min-width: 960px) {
          display: none;
        }
      }

      &.hiddenMobile {
        @media (max-width: 770px) {
          display: none;
        }
      }
    }
  }
}
`
